import * as yup from 'yup'

export class CompanyExporterInformationDto {
  exporterDealerNumber?: string = undefined
  exporterDescription?: string = undefined
  exporterIrsNumber?: string = undefined
  exporterCode?: string = undefined
}

export const companyExporterInformationValidationSchema = yup.object<CompanyExporterInformationDto>({
  exporterDealerNumber: yup.string().max(200, 'Dealer # cannot be more than 200 characters.').required('Dealer # is required.'),
  exporterDescription: yup
    .string()
    .max(200, 'Description cannot be more than 200 characters.')
    .required('Description is required.'),
  exporterIrsNumber: yup.string().max(200, 'IRS # cannot be more than 200 characters.').required('IRS # is required.'),
  exporterCode: yup
    .string()
    .min(3, 'Exporter Code must be 3 characters.')
    .max(3, 'Exporter Code must be 3 characters.')
    .required('Exporter Code is required.')
})
